/**
 * Checkpoint GraphQL Mutations (3 total)
 *
 * Complete mutation coverage for Checkpoint primitive:
 * 1. createCheckpoint - Standard checkpoint creation
 * 2. createSagaCompensationCheckpoint - Formula #4 constructor
 * 3. validateCheckpointIntegrity - SHA-256 checksum verification
 *
 * NOTE: tenantId is resolved from AuthCtx on the backend (not passed as parameter)
 */

import { gql } from '@apollo/client';
import { CHECKPOINT_FIELDS, VALIDATION_RESULT_FIELDS } from './fragments';

/**
 * Create standard checkpoint
 */
export const CREATE_CHECKPOINT = gql`
  ${CHECKPOINT_FIELDS}
  mutation CreateCheckpoint($input: CreateCheckpointInput!) {
    createCheckpoint(input: $input) {
      ...CheckpointFields
    }
  }
`;

/**
 * Create saga compensation checkpoint (Formula #4)
 */
export const CREATE_SAGA_COMPENSATION_CHECKPOINT = gql`
  ${CHECKPOINT_FIELDS}
  mutation CreateSagaCompensationCheckpoint(
    $input: SagaCompensationCheckpointInput!
  ) {
    createSagaCompensationCheckpoint(input: $input) {
      ...CheckpointFields
    }
  }
`;

/**
 * Validate checkpoint integrity (checksum verification)
 */
export const VALIDATE_CHECKPOINT_INTEGRITY = gql`
  ${VALIDATION_RESULT_FIELDS}
  mutation ValidateCheckpointIntegrity($checkpointId: String!) {
    validateCheckpointIntegrity(checkpointId: $checkpointId) {
      ...ValidationResultFields
    }
  }
`;
